// extracted by extract-css-chunks-webpack-plugin
module.exports = {"survey_title":"survey_title-aRU1uJPS","box":"box-33V-dvrS","logo":"logo-QoeTsMHh","icon":"icon-2qHrN0uJ","title":"title-E5ZDPBRc"};